module.exports = __webpack_public_path__ + "img/cooperation3.80c0a3bd.png";